import { getContestsFromStore } from '../contest-store.js'

// Contest configuration
const CURRENT_YEAR = new Date().getFullYear()
const COMPETITION_ID = `hween_${CURRENT_YEAR}`

function getContestBandLeaderboardFromScoreId(scoreId) {
  // To enable mission/objective level leaderboards, we need to find the mission pack from this lessonContent object.
  // const lessonContent = getLessonContentItemByScoreId(scoreId)
  // const contest = getContestsFromStore().find(contest => contest.missionPackId === lessonContent.pack.id)
  const contest = getContestsFromStore().find(contest => contest.id === COMPETITION_ID)

  const leaderboardsByScoreId = contest?.leaderboardsByScoreId
  if (!leaderboardsByScoreId) {
    return
  }

  const key = Object.keys(leaderboardsByScoreId)?.find(id => !id.startsWith('default'))
  if (!(key in leaderboardsByScoreId) || !leaderboardsByScoreId[key] || !(scoreId in leaderboardsByScoreId[key])) {
    return
  }
  return leaderboardsByScoreId[key][scoreId]
}

export { getContestBandLeaderboardFromScoreId }